module.exports = __webpack_public_path__ + "static/media/dj.16e3de24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/dj.svg
// module id = 99
// module chunks = 0